export default "__VITE_ASSET__CPHP$sAa__"